module.exports = __webpack_public_path__ + "static/img/img.49a5e42f.jpg";